import React, {useState} from 'react'
import HorizontalBarChart from '../diagrams/HorizontalBarChart';
import Modal from '../utils/Modal';

function JflStats(teams) {

  const [isModalOpen, setIsModalOpen] = useState(false);

  const getJflStats = () => {
    return teams.teams.map(team => ({
      nameText: team.name + '&nbsp; <img class="logo-team-small" src="'+team.url_logo+'" alt="'+team.url_logo+'"></img>',
      name: '<img class="logo-team-small" src="'+team.url_logo+'" alt="'+team.url_logo+'"></img>',
      value: team.players !== undefined ?team.players.filter(player => player.licence === "JFL").length : 0
    })).sort((a, b) => b.value - a.value);
  } 
  
  const getTopJflStats = () => {
    return getJflStats().slice(0, 6);
  }

  const getBottomJflStats = () => {
    return getJflStats().sort((a, b) => a.value - b.value).slice(0, 6);
  }

  const setupChart = {
    justifyContentLabel: 'center',
    percentage: false
  }
  return (
    <div>
      <p><b>Equipos con más JFLs</b></p>
      <HorizontalBarChart data={getTopJflStats()} setup={setupChart}/>
      <p><b>Equipos con menos JFLs</b></p>
      <HorizontalBarChart data={getBottomJflStats()} setup={setupChart}/>
      <button className="btn-all-data" onClick={() => setIsModalOpen(true)}>
        Ver todos los datos
      </button>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <table className="table-stats">
          <thead>
            <tr>
              <th>Equipo</th>
              <th>Nº de jugadores JFL</th>
            </tr>
          </thead>
          <tbody>
          {getJflStats().map((item, index) => (
            <tr key={index}>
              <td><div className="label-team" dangerouslySetInnerHTML={{ __html: item.nameText }}></div></td><td className="td-value"> {item.value}</td>
            </tr>
          ))}
          </tbody>
        </table>
      </Modal>
    </div>
  )
}

export default JflStats